import React from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const InvoiceGenerator = ({
  permitHolderName,
  invoiceNumber,
  totalTT,
  totalSkole,
  totalPasientreiser,
  totalOrdinær,
  totalCash,
  totalgeneralCredit,
  totalcreditCard,
}) => {
  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(20);
    doc.text("Faktura", 105, 20, { align: "center" });

    doc.setFontSize(12);
    doc.text(`Navn på løyvehaver: ${permitHolderName}`, 20, 40);
    doc.text(`Fakturanummer: ${invoiceNumber}`, 20, 50);

    doc.autoTable({
      startY: 70,
      head: [["Beskrivelse", "Beløp (NOK)"]],
      body: [
        ["Total TT", totalTT.toFixed(2)],
        ["Total Skole", totalSkole.toFixed(2)],
        ["Total Pasientreiser", totalPasientreiser.toFixed(2)],
        ["Total Ordinær", totalOrdinær.toFixed(2)],
        ["Total General Credit", totalgeneralCredit.toFixed(2)],
        ["Total Credit Card", totalcreditCard.toFixed(2)],

        ["Total Cash (Trekkes fra)", `-${totalCash.toFixed(2)}`],
        [
          "Sum Total",
          (
            totalTT +
            totalSkole +
            totalPasientreiser +
            totalgeneralCredit +
            totalcreditCard +
            totalOrdinær -
            totalCash
          ).toFixed(2),
        ],
      ],
    });

    doc.save(`faktura_${invoiceNumber}.pdf`);
  };

  return (
    <div>
      <button
        onClick={generatePDF}
        className="p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Last ned faktura
      </button>
    </div>
  );
};

export default InvoiceGenerator;
